import { render, staticRenderFns } from "./CustomerTagEdit.vue?vue&type=template&id=135ec31e&"
import script from "./CustomerTagEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerTagEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports